/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Left_TitleInputs */

const en_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Bottom Left`)
};

const fr_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : En Bas a Gauche`)
};

const de_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Unten links`)
};

const it_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: in basso a sinistra`)
};

const ru_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Нижний левый угол`)
};

const es_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Abajo a la izquierda`)
};

const zh_cn2_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：左下角`)
};

const ja_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置: 左下`)
};

const hi_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: नीचे बाएँ`)
};

const pt_pt2_position_bottom_left_title = /** @type {(inputs: Position_Bottom_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Inferior Esquerda`)
};

/**
* | output |
* | --- |
* | "Position: Bottom Left" |
*
* @param {Position_Bottom_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_left_title = /** @type {((inputs?: Position_Bottom_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_bottom_left_title(inputs)
	if (locale === "de") return de_position_bottom_left_title(inputs)
	if (locale === "it") return it_position_bottom_left_title(inputs)
	if (locale === "ru") return ru_position_bottom_left_title(inputs)
	if (locale === "es") return es_position_bottom_left_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_bottom_left_title(inputs)
	if (locale === "ja") return ja_position_bottom_left_title(inputs)
	if (locale === "hi") return hi_position_bottom_left_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_bottom_left_title(inputs)
	return en_position_bottom_left_title(inputs)
});